import React, { useContext, useState } from "react";
import { useEffect } from "react";
import Application from "../../components/application";
import Button from "@mui/material/Button";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { useNavigate } from "react-router-dom";
import PaginationGridView from "../../components/views/paginationGridView";
import {Tooltip} from "@mui/material";
import useLocalTarefa from "../../hooks/useLocalTarefa";
import QrcodeModal from "./localTarefaFormulario/qrcodeModal";
import TELAS from "../../constants/telas"; // permissão para telas
import { AuthContext } from "../../contexts/auth";
import TELA_ACOES from "../../constants/telaAcoes";
import permissaoTelas from "../../utils/permissaoTelas";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';

const PAGINA = {
    aplicacao: 'SisPalo - Tarefas',
    funcionalidade: 'Tarefas',
    tela: TELAS.LOCAIS_DE_TAREFAS,
    acoes: [TELA_ACOES.Consultar,TELA_ACOES.Incluir, TELA_ACOES.Alterar, TELA_ACOES.Apagar, TELA_ACOES.QrCode]
}

const LocalTarefa = () => {

    const states = useLocalTarefa()
    const navigate = useNavigate()
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/

    const [openModal, setOpenModal] = useState(false);    
    const [idLocal, setIdLocal] = useState(false);    
    const [nomeLocal, setNomeLocal] = useState('');        
    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);    
    

    useEffect(()=>{
        if (states.pesquisa.value === ''){
            states.submit.set()
        }

    }, [states.pesquisa.value])

    /* permissão para telas*/
    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar,PAGINA)){
            if (states.pesquisa.value === ''){
                states.submit.set()
            }
        }
        else {
            navigate('/gestor/dashboard')
        }

    }, [])

    const columns = [
        {field:'id', headerName:'ID', width: 80},
        {field:'name', headerName:'Nome Local', flex: 1},
        {field:'CodPosto', headerName:'Cód Posto', width: 100},
        {field:'nome_posto', headerName:'Nome do Posto', flex: 1},
        {field:'ativo', headerName:'Ativo', width: 50, renderCell: (cellValues) =>{
            return (
                <Tooltip title="Ativo" placement="bottom" arrow>
                        {
                            cellValues.row.ativo ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                        }
                </Tooltip>                
                )
            }
        },
        {field:'editavel', headerName:'Editável', width: 100, renderCell: (cellValues) =>{
            return (
                <Tooltip title="é editável" placement="bottom" arrow>
                        {
                            cellValues.row.editavel ? <CheckCircleOutlinedIcon /> : <RadioButtonUncheckedOutlinedIcon/>
                        }
                </Tooltip>                
                )
            }
        },
        {filed:'', headerName:'Ações', width:110, renderCell: (cellValues) =>{
            return (
                <>
                    <Tooltip title="Apagar" placement="bottom" arrow>
                        <Button color='error' disabled={
                            !permissaoTelas(permissaoUsuario, TELA_ACOES.Apagar,PAGINA) || 
                            cellValues.row.quantidade_tarefas>0
                            } onClick={()=>{states.itemDelete.set(cellValues.row);states.openDialog.set(true)}} sx={{width:'55px', padding: 0,minWidth:0}}><DeleteIcon /></Button>
                    </Tooltip>
                    <Tooltip title="Editar" placement="bottom" arrow>
                            <Button disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar,PAGINA)}
                            onClick={()=>navigate(`/gestor/localtarefa/formulario/${cellValues.row.id}`)} sx={{width:'55px', padding: 0,minWidth:0}}><EditIcon /></Button>
                    </Tooltip>
                    <Tooltip title="gera QRcode" placement="bottom" arrow>
                        <Button disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.QrCode,PAGINA) || !cellValues.row.editavel} 
                        onClick={()=>{handleOpen();setIdLocal(cellValues.row.id);setNomeLocal(cellValues.row.name)}} 
                        sx={{width:'55px', padding: 0,minWidth:0}}><QrCode2Icon /></Button>                        
                    </Tooltip>
                </>
                
            )
        }}
    ]
    
    return (
        <Application>
            <>
                <QrcodeModal 
                    open={openModal} 
                    handleClose={handleClose} 
                    idlocal={idLocal}
                    states={states}
                    nomeLocal={nomeLocal}
                />                
                <PaginationGridView 
                    title='Local da Tarefa' 
                    states={states}
                    rows={states.localTarefa.value}
                    columns={columns}
                    urlAdd={permissaoTelas(permissaoUsuario, TELA_ACOES.Incluir,PAGINA)? `/gestor/localtarefa/formulario`: null}
                    urlVoltar={'/gestor/dashboard'}                    
                    onClickPesquisa={() => {
                        states.pagination.setPage(0);
                        states.submit.set(1); 
                    }}
                    nomeItem='Local Tarefa'
                    children={null}
                    modalAdd={null}
                />
            </>
        </Application>
   
    )
}

export default LocalTarefa;